import { useState } from 'react';
import { Button, ErrorState } from '@/components/ui';
import { downloadFile } from '@/features/admin-v2/download';

/** Downloads an authenticated file (e.g. a CSV) and shows any error under the button. */
export function FileButton({
  path,
  name,
  label,
  disabled,
}: {
  path: string;
  name: string;
  label: string;
  disabled?: boolean;
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();
  return (
    <>
      <Button
        size="sm"
        loading={loading}
        disabled={disabled}
        onClick={() => {
          setLoading(true);
          setError(undefined);
          void downloadFile(path, name)
            .catch(setError)
            .finally(() => setLoading(false));
        }}
      >
        {label}
      </Button>
      {error !== undefined && <ErrorState error={error} />}
    </>
  );
}
